import { useNavigate } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { ApprovalRequestMessage } from '../../../types/ApprovalRequestMessage';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { OverlayHeader } from '../../common/Overlay/OverlayHeader';
import { ReadOnlyProductTable } from '../../common/ReadOnlyProductTable/ReadOnlyProductTable';
import { Box } from '../../common/ui/Box';
import { OfferModel } from '../model/OfferModel';
import { CustomerApprovalDataSheet } from '../OfferCoreData/CustomerApprovalDataSheet';

import { ApprovalRequestContentContainer } from './ApprovalRequestContentContainer';
import { ApprovalRequestsDropdown } from './Dropdown/ApprovalRequestsDropdown';

interface ApprovalRequestBasicContentProps {
    offer: OfferModel;
    approvalRequests: ApprovalRequestMessage[];
    children: ReactNode;
    shouldDisplayBackButton?: boolean;
}

export const ApprovalRequestBasicContent = ({
    offer,
    approvalRequests,
    children,
    shouldDisplayBackButton,
}: ApprovalRequestBasicContentProps) => {
    const navigate = useNavigate();

    const handleClose = shouldDisplayBackButton ? () => navigate({ to: '/dashboard' }) : undefined;

    return (
        <OverlayHeader
            title={
                <Box display="flex" gap={16}>
                    <Text variant="title">{translate('approvalRequest.header.title')}</Text>
                    <Text variant="title" color="foreground.subtle">
                        {offer.offerNumber}
                    </Text>
                </Box>
            }
            onClose={handleClose}
            trailingVisual={<ApprovalRequestsDropdown approvalRequests={approvalRequests} />}
        >
            <ApprovalRequestContentContainer>
                {children}
                <CustomerApprovalDataSheet offer={offer} />
                <ReadOnlyProductTable
                    items={offer.items}
                    surcharges={offer.surcharges}
                    sampleKits={offer.samplekits}
                    totals={{ volume: offer.volume, price: offer.ppl, total: offer.total }}
                    showPrices
                />
            </ApprovalRequestContentContainer>
        </OverlayHeader>
    );
};
